export default class LeadFormListener {
    constructor(formSelector = '.form-lead', buttonLoadingContent = null) {
        const { __ } = wp.i18n;

        if (buttonLoadingContent === null) {
            buttonLoadingContent = '<i class="fas fa-fw fa-spinner fa-spin"></i>' + __('Loading', 'rwn');
        }

        document.addEventListener("DOMContentLoaded", () => {
            (function () {
                'use strict';
                window.addEventListener('DOMContentLoaded', function () {
                    // Fetch all the forms we want to apply custom Bootstrap validation styles to
                    let forms = document.querySelectorAll(formSelector);
                    // Loop over them and prevent submission
                    let validation = Array.prototype.filter.call(forms, function (form) {
                        form.addEventListener('submit', function (event) {
                            if (form.checkValidity() === false) {
                                event.preventDefault();
                                event.stopPropagation();
                                alert(__("Please correct the fields marked in red", 'rwn'));
                            } else {
                                event.preventDefault();
                                const submitButton = form.querySelector('button[type="submit"]');
                                const submitUrl = form.getAttribute('data-submit-url');
                                submitButton.innerHTML = buttonLoadingContent;
                                submitButton.setAttribute('disabled', 'disabled');

                                if (typeof grecaptcha === 'undefined') {
                                    LeadFormListener.prototype.sendRequest(form, submitUrl, submitButton);
                                } else {
                                    grecaptcha.ready(function () {
                                        const recaptchaPublicKey = form.getAttribute('data-recaptcha-public-key');
                                        grecaptcha.execute(recaptchaPublicKey, {action: 'submit'}).then(function (token) {
                                            LeadFormListener.prototype.sendRequest(form, submitUrl, submitButton, token);
                                        });
                                    });
                                }
                            }
                            form.classList.add('was-validated'); // todo dodanie walidacji po server side!
                        }, false);
                    });
                }, false);
            })();
        });
    }

    sendRequest(form, submitUrl, submitButton, token = null) {
        const { __ } = wp.i18n;

        let formData = new FormData(form);
        if (token !== null) {
            formData.append('recaptcha_token', token);
        }

        fetch(submitUrl, {
            method: 'POST',
            cache: 'no-cache',
            body: formData
        }).then(async result => {
            let resultJson = await result.json();
            // todo thank you message
            alert(resultJson.data.message);
            if (result.status === 200) {
                submitButton.innerHTML = __('Sent', 'rwn');
            } else {
                submitButton.innerHTML = __('Try again', 'rwn');
                submitButton.removeAttribute('disabled');
            }
        }).catch(async error => {
            alert(__('Unknown error', 'rwn'));
            // todo developer message, powinno zwracać na backendzie. Jeśli niepuste to znaczy, że jest debug on!
            submitButton.innerHTML = __('Try again', 'rwn');
            submitButton.removeAttribute('disabled');
        })
    }
}